"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertMultiSelectResponsesWithOldDataSourceValues = exports.assertMultiSelectResponsesWithDisplayConditions = exports.assertMultiSelectResponsesWithDataSources = void 0;
function assertMultiSelectResponsesWithDataSources(handleSubmissionMock, responses) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(4);
    var customResponse = responses.find(function (r) { return r.questionId === 1195404; });
    expect(customResponse.answer).toBe("Option 1");
    expect(customResponse.associatedId).toBe(1195553);
    expect(customResponse.associatedRootId).toBe(1195553);
    expect(customResponse.questionId).toBe(1195404);
    expect(customResponse.questionRootId).toBe(1195404);
    var color1Response = responses.find(function (r) { return r.questionId === 1195204 && r.answer === "Blue"; });
    expect(color1Response.answer).toBe("Blue");
    expect(color1Response.associatedId).toBe(1190205);
    expect(color1Response.associatedRootId).toBeUndefined();
    expect(color1Response.questionId).toBe(1195204);
    expect(color1Response.questionRootId).toBe(1195204);
    var color2Response = responses.find(function (r) { return r.questionId === 1195204 && r.answer === "Green"; });
    expect(color2Response.answer).toBe("Green");
    expect(color2Response.associatedId).toBe(1190204);
    expect(color2Response.associatedRootId).toBeUndefined();
    expect(color2Response.questionId).toBe(1195204);
    expect(color2Response.questionRootId).toBe(1195204);
    var locationResponse = responses.find(function (r) { return r.questionId === 1195405; });
    expect(locationResponse.answer).toBe("502 JUNCTION");
    expect(locationResponse.associatedId).toBe(26986);
    expect(locationResponse.associatedRootId).toBeUndefined();
    expect(locationResponse.questionId).toBe(1195405);
    expect(locationResponse.questionRootId).toBe(1195405);
    expect(locationResponse.associatedLocation).toBeUndefined();
}
exports.assertMultiSelectResponsesWithDataSources = assertMultiSelectResponsesWithDataSources;
function assertMultiSelectResponsesWithDisplayConditions(handleSubmissionMock, responses) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(15);
    var colorsResponses = responses.filter(function (r) { return r.questionId === 1227151; });
    expect(colorsResponses[0].answer).toBe("Green");
    expect(colorsResponses[0].associatedId).toBe(1190204);
    expect(colorsResponses[0].questionId).toBe(1227151);
    expect(colorsResponses[0].questionRootId).toBe(1227151);
    expect(colorsResponses[1].answer).toBe("Blue");
    expect(colorsResponses[1].associatedId).toBe(1190205);
    expect(colorsResponses[1].questionId).toBe(1227151);
    expect(colorsResponses[1].questionRootId).toBe(1227151);
    var participantResponse = responses.find(function (r) { return r.questionId === 1227152; });
    expect(participantResponse.answer).toBe("Blue");
    expect(participantResponse.questionId).toBe(1227152);
    expect(participantResponse.questionRootId).toBe(1227152);
    var multiSelectResponses = responses.filter(function (r) { return r.questionId === 1227153; });
    var greenMsResponse = multiSelectResponses.find(function (r) { return r.answer === "Green"; });
    expect(greenMsResponse.answer).toBe("Green");
    expect(greenMsResponse.questionId).toBe(1227153);
    expect(greenMsResponse.questionRootId).toBe(1227153);
    var blueMsResponse = multiSelectResponses.find(function (r) { return r.answer === "Blue"; });
    expect(blueMsResponse.answer).toBe("Blue");
    expect(blueMsResponse.questionId).toBe(1227153);
    expect(blueMsResponse.questionRootId).toBe(1227153);
    var customMultiSelectResponse = responses.filter(function (r) { return r.questionId === 1227457; });
    var greenCmsResponse = customMultiSelectResponse.find(function (r) { return r.answer === "green"; });
    expect(greenCmsResponse.answer).toBe("green");
    expect(greenCmsResponse.questionId).toBe(1227457);
    expect(greenCmsResponse.questionRootId).toBe(1227457);
    expect(greenCmsResponse.associatedId).toBe(1227703);
    expect(greenCmsResponse.associatedRootId).toBe(0);
    var blueCmsResponse = customMultiSelectResponse.find(function (r) { return r.answer === "Blue"; });
    expect(blueCmsResponse.answer).toBe("Blue");
    expect(blueCmsResponse.questionId).toBe(1227457);
    expect(blueCmsResponse.questionRootId).toBe(1227457);
    expect(blueCmsResponse.associatedId).toBeUndefined();
    expect(blueCmsResponse.associatedRootId).toBeUndefined();
    var radioResponse = responses.find(function (r) { return r.questionId === 1227452; });
    expect(radioResponse.answer).toBe("Blue");
    expect(radioResponse.questionId).toBe(1227452);
    expect(radioResponse.questionRootId).toBe(1227452);
    var dropdownResponse = responses.find(function (r) { return r.questionId === 1227155; });
    expect(dropdownResponse.answer).toBe("Blue");
    expect(dropdownResponse.questionId).toBe(1227155);
    expect(dropdownResponse.questionRootId).toBe(1227155);
    var textLineResponse = responses.find(function (r) { return r.questionId === 1227453; });
    expect(textLineResponse.answer).toBe("Blue");
    expect(textLineResponse.questionId).toBe(1227453);
    expect(textLineResponse.questionRootId).toBe(1227453);
    var textAreaResponse = responses.find(function (r) { return r.questionId === 1227454; });
    expect(textAreaResponse.answer).toBe("Blue");
    expect(textAreaResponse.questionId).toBe(1227454);
    expect(textAreaResponse.questionRootId).toBe(1227454);
}
exports.assertMultiSelectResponsesWithDisplayConditions = assertMultiSelectResponsesWithDisplayConditions;
function assertMultiSelectResponsesWithOldDataSourceValues(handleSubmissionMock, responses) {
    expect(handleSubmissionMock.mock.calls.length).toBe(1);
    expect(responses.length).toBe(2);
    var color1Response = responses.find(function (r) { return r.questionId === 1195204 && r.answer === "Cherry"; });
    expect(color1Response.answer).toBe("Cherry");
    expect(color1Response.associatedId).toBe(1190000);
    expect(color1Response.associatedRootId).toBeUndefined();
    expect(color1Response.questionId).toBe(1195204);
    expect(color1Response.questionRootId).toBe(1195204);
    var color2Response = responses.find(function (r) { return r.questionId === 1195204 && r.answer === "Green"; });
    expect(color2Response.answer).toBe("Green");
    expect(color2Response.associatedId).toBe(1190204);
    expect(color2Response.associatedRootId).toBeUndefined();
    expect(color2Response.questionId).toBe(1195204);
    expect(color2Response.questionRootId).toBe(1195204);
}
exports.assertMultiSelectResponsesWithOldDataSourceValues = assertMultiSelectResponsesWithOldDataSourceValues;
//# sourceMappingURL=mutliSelectResponses.js.map